export default __webpack_public_path__ + "static/media/spark_18.9dc09807.png";